import {
  all,
  call,
  put,
  takeEvery,
  takeLatest,
  select,
} from 'redux-saga/effects';
import qs from 'qs';
import SUCCESS_MESSAGES from '../../../common/constants/SuccessMessagesConstants';
import {
  DEFAULT_TASK_PRE_FILTER_KEYS,
  TASK_STATUS,
  TASK_TYPE,
  TASK_VIEW_MODES,
} from '../../../common/constants/TaskConstants';
import { request } from '../../../common/util/RestClient';
import envConfig from '../../../config';
import { fetchActivities } from '../../routines';
import {
  archiveTask,
  completeTask,
  resolveChecklist,
  createTask,
  editTask,
  fetchAllTasks,
  fetchTasksByEntity,
  fetchTasksById,
  fetchTasksByIds,
  markInProgressTask,
  reAssignTask,
  bookmarkTask,
  fetchTaskChangelog,
  exportTasks,
  refreshTaskForBoardView,
  fetchPartialTasks,
  putTask,
  logTime,
  deleteTaskWorkLog,
  fetchMoreTasksByEntity,
  editEntityTask,
  completeEntityTask,
  refreshEntityTask,
} from '../../routines/taskRoutines';
import {
  BOOLEAN_MAP,
  GLOBAL_DEFAULT_PAGE_SIZE,
} from '../../../common/constants/CommonConstants';
import { convertFilterToVfl } from '../../../common/util/velarisFilterLanguageUtils';
import onAntdTableExport from '../../../common/util/onAntdTableExport';
import { GTM_TRACK_EVENT } from '../../../common/GoogleTagManager/GoogleTagManager';
import { GTM_EVENTS } from '../../../common/GoogleTagManager/GTMEventConstants';

const TASK_URL = `${envConfig.APIG_URL}playbook/tasks`;
const PM_URL = `${envConfig.APIG_URL}project-mgt/tasks`;

export function getTasksApiHelper(payload = {}) {
  const {
    page,
    pageSize,
    sortColumn,
    sortDirection,
    query,
    filters,
    myTasksOnly,
    taskType,
    dateBreakdownFilter,
  } = payload || {};
  const params = {
    page: page || 1,
    pageSize: pageSize || GLOBAL_DEFAULT_PAGE_SIZE,
    myTasksOnly,
    taskType,
    dateBreakdownFilter,
  };
  if (sortColumn && sortDirection) {
    params.sortColumn = sortColumn;
    params.sortDirection = sortDirection;
  }
  if (filters && filters.length > 0) {
    const preKeyValue = filters.find((filter) =>
      DEFAULT_TASK_PRE_FILTER_KEYS.includes(filter.key)
    );
    params.isPreFilterKeyAvailable = !!preKeyValue;
    params.filters = convertFilterToVfl(filters);
  }

  if (query && query.length > 0) {
    params.query = query;
  }

  const url = `${PM_URL}?${qs.stringify(params)}`;
  return request(url);
}
export function* exportTasksSaga({ payload }) {
  const { params, columnConfig } = payload;
  const exportPayload = {
    ...params,
    page: 1,
    pageSize: Number.MAX_SAFE_INTEGER,
  };
  const response = yield call(getTasksApiHelper, exportPayload);
  const taskList = response?.data?.tasks || [];
  yield call(onAntdTableExport(taskList || [], columnConfig));
}

export function* fetchAllTasksSaga({ payload }) {
  const { currentPayload: prevPayload } = yield select((state) => state.tasks);

  const payloadToUse =
    payload && payload.usePrevPayload ? prevPayload : payload;

  try {
    const response = yield call(getTasksApiHelper, payloadToUse);
    yield put(
      fetchAllTasks.success({
        response: response.data,
        currentPayload: payloadToUse,
      })
    );
  } catch (error) {
    yield put(fetchAllTasks.failure({ error }));
  } finally {
    yield put(fetchAllTasks.fulfill());
  }
}

export function* fetchPartialTasksSaga({ payload }) {
  const queryString = payload?.query ? `?query=${payload.query}` : '';
  try {
    const response = yield call(request, `${PM_URL}/partial${queryString}`);
    yield put(fetchPartialTasks.success(response.data));
  } catch (error) {
    yield put(fetchPartialTasks.failure({ error }));
  } finally {
    yield put(fetchPartialTasks.fulfill());
  }
}

export function* fetchTasksByEntitySaga({ payload }) {
  const { currentPayload: prevPayload } = yield select((state) => state.tasks);
  const payloadToUse =
    payload && payload.usePrevPayload ? prevPayload : payload;
  const { level, entityId, paginationParams, filters, query } = payloadToUse;

  try {
    const params = {
      ...paginationParams,
    };

    if (filters && filters.length > 0) {
      params.filters = convertFilterToVfl(filters);
    }
    if (query && query.length > 0) {
      params.query = query;
    }

    let URL = `${PM_URL}/search?sortDirection=DESC&sortColumn=dueDate&parentIdentifier=${entityId}&level=${level.toUpperCase()}`;
    if (Object.keys(params).length > 0) {
      URL = `${URL}&${qs.stringify(params)}`;
    }

    const response = yield call(request, URL);
    yield put(
      fetchTasksByEntity.success({ ...response, currentPayload: payloadToUse })
    );
  } catch (error) {
    yield put(fetchTasksByEntity.failure({ error }));
  } finally {
    yield put(fetchTasksByEntity.fulfill());
  }
}

export function* fetchLoadMoreTasksByEntitySaga({ payload }) {
  try {
    const { level, entityId, paginationParams, filters, query } = payload;
    const params = {
      ...paginationParams,
    };
    if (filters && filters.length > 0) {
      params.filters = convertFilterToVfl(filters);
    }

    if (query && query.length > 0) {
      params.query = query;
    }

    let URL = `${PM_URL}/search?sortDirection=DESC&sortColumn=dueDate&parentIdentifier=${entityId}&level=${level.toUpperCase()}`;
    if (Object.keys(params).length > 0) {
      URL = `${URL}&${qs.stringify(params)}`;
    }

    const response = yield call(request, URL);
    yield put(fetchMoreTasksByEntity.success(response));
  } catch (error) {
    yield put(fetchMoreTasksByEntity.failure({ error }));
  }
}

export function* fetchTasksByIdSaga({ payload }) {
  try {
    const { taskId } = payload;
    const response = yield call(request, `${PM_URL}/${taskId}`);
    yield put(fetchTasksById.success({ response, taskId }));
  } catch (error) {
    yield put(fetchTasksById.failure({ error }));
  } finally {
    yield put(fetchTasksById.fulfill());
  }
}

export function* fetchTasksByIdsSaga({ payload }) {
  try {
    const { taskIds } = payload;
    const response = yield call(request, `${PM_URL}/get-by-ids`, {
      method: 'POST',
      payload: { taskIds },
    });
    yield put(fetchTasksByIds.success({ response, taskIds }));
  } catch (error) {
    yield put(fetchTasksByIds.failure({ error }));
  } finally {
    yield put(fetchTasksByIds.fulfill());
  }
}

export function* fetchTaskChangelogByTaskIdSaga({ payload }) {
  try {
    const { associatedItemId: taskId } = payload;
    const response = yield call(request, `${TASK_URL}/${taskId}/changelog`);
    yield put(fetchTaskChangelog.success(response));
  } catch (error) {
    yield put(fetchTaskChangelog.failure({ error }));
  } finally {
    yield put(fetchTaskChangelog.fulfill());
  }
}

export function* archiveTaskSaga({ payload }) {
  try {
    let taskIds = payload;
    let onSuccess = null;
    if (payload.taskIds) {
      taskIds = payload.taskIds;
      onSuccess = payload.onSuccess;
    }
    const response = yield call(request, `${PM_URL}/archive`, {
      method: 'POST',
      payload: { taskIds },
    });
    yield put(
      archiveTask.success({
        response,
        successMessage: SUCCESS_MESSAGES.ARCHIVE_TASK,
      })
    );
    if (onSuccess) {
      onSuccess();
    }
    if (payload.boardView) {
      yield put(refreshTaskForBoardView.trigger());
    } else if (payload.isActivityFeed) {
      yield put(
        fetchTasksByEntity.trigger({ usePrevPayload: BOOLEAN_MAP.TRUE })
      );
    } else {
      yield put(fetchAllTasks.trigger({ usePrevPayload: BOOLEAN_MAP.TRUE }));
    }
  } catch (error) {
    yield put(archiveTask.failure({ error }));
  } finally {
    yield put(archiveTask.fulfill());
  }
}

export function* completeTaskSaga({ payload }) {
  try {
    GTM_TRACK_EVENT(GTM_EVENTS.ACTIONS_TASKS_COMPLETED);
    let taskIds = payload;
    let onComplete = null;
    if (payload.taskIds) {
      taskIds = payload.taskIds;
      onComplete = payload.onComplete;
    }
    const response = yield call(request, `${PM_URL}/complete`, {
      method: 'POST',
      payload: { taskIds },
    });

    if (onComplete) onComplete(response?.data);
    yield put(
      completeTask.success({
        response,
        successMessage: SUCCESS_MESSAGES.COMPLETE_TASK,
      })
    );
    if (payload.boardView) {
      yield put(refreshTaskForBoardView.trigger());
    } else {
      yield put(fetchAllTasks.trigger({ usePrevPayload: true }));
    }
  } catch (error) {
    yield put(completeTask.failure({ error }));
  } finally {
    yield put(completeTask.fulfill());
  }
}

export function* completeEntityTaskSaga({ payload }) {
  const { taskIds } = payload;
  try {
    const response = yield call(request, `${PM_URL}/complete`, {
      method: 'POST',
      payload: {
        taskIds,
      },
    });
    yield put(
      completeEntityTask.success({
        response,
        successMessage: SUCCESS_MESSAGES.COMPLETE_TASK,
      })
    );
  } catch (error) {
    yield put(completeEntityTask.failure({ error }));
  } finally {
    yield put(completeEntityTask.fulfill());
  }
}

export function* resolveChecklistSaga({ payload }) {
  try {
    const response = yield call(request, `${TASK_URL}/complete-checklist`, {
      method: 'POST',
      payload: { taskIds: payload },
    });
    yield put(
      resolveChecklist.success({
        response,
        successMessage: SUCCESS_MESSAGES.RESOLVE_TASK,
      })
    );
    yield put(fetchAllTasks.trigger({ usePrevPayload: true }));
  } catch (error) {
    yield put(resolveChecklist.failure({ error }));
  } finally {
    yield put(resolveChecklist.fulfill());
  }
}

export function* markInProgressTaskSaga({ payload }) {
  try {
    let taskIds = payload;
    let onComplete = null;
    if (payload.taskIds) {
      taskIds = payload.taskIds;
      onComplete = payload.onComplete;
    }
    const response = yield call(request, `${TASK_URL}/in-progress`, {
      method: 'POST',
      payload: { taskIds },
    });
    if (onComplete) onComplete();
    yield put(
      markInProgressTask.success({
        response,
        successMessage: SUCCESS_MESSAGES.MARK_IN_PROGRESS_TASK,
      })
    );
    if (payload.boardView) {
      yield put(refreshTaskForBoardView.trigger());
    } else {
      yield put(fetchAllTasks.trigger({ usePrevPayload: true }));
    }
  } catch (error) {
    yield put(markInProgressTask.failure({ error }));
  } finally {
    yield put(markInProgressTask.fulfill());
  }
}

export function* reAssignTaskSaga({ payload }) {
  try {
    const response = yield call(request, `${PM_URL}/reassign`, {
      method: 'POST',
      payload,
    });
    yield put(
      reAssignTask.success({
        response,
        successMessage: SUCCESS_MESSAGES.REASSIGN_TASK,
      })
    );
    yield put(fetchAllTasks.trigger({ usePrevPayload: true }));
  } catch (error) {
    yield put(reAssignTask.failure({ error }));
  } finally {
    yield put(reAssignTask.fulfill());
  }
}

export function* bookmarkTaskSaga({ payload }) {
  try {
    const { taskId, formData } = payload;
    const { bookmarkStatus } = formData;

    const response = yield call(request, `${PM_URL}/${taskId}/bookmark`, {
      method: 'PATCH',
      payload: formData,
    });
    yield put(
      bookmarkTask.success({
        response,
        successMessage:
          bookmarkStatus === 1
            ? SUCCESS_MESSAGES.BOOKMARK_TASK
            : SUCCESS_MESSAGES.REMOVE_BOOKMARK_TASK,
      })
    );
  } catch (err) {
    yield put(bookmarkTask.failure({ error: err }));
  }
}

export function* createTaskSaga({ payload }) {
  try {
    GTM_TRACK_EVENT(GTM_EVENTS.ACTIONS_TASKS_CREATED);
    const {
      formData,
      level,
      entityId,
      onCreateComplete,
      viewMode = TASK_VIEW_MODES.LIST,
    } = payload;
    const response = yield call(request, `${PM_URL}`, {
      method: 'POST',
      payload: formData,
    });
    yield put(
      createTask.success({
        response,
        ...(payload.formData.taskType !== TASK_TYPE.SUCCESS_PLAN && {
          successMessage: SUCCESS_MESSAGES.CREATE_TASK,
        }),
      })
    );
    if (onCreateComplete) {
      onCreateComplete(response.data);
    }
    if (level && entityId) {
      yield put(refreshEntityTask.trigger(Math.random()));
    } else if (viewMode === TASK_VIEW_MODES.LIST) {
      yield put(fetchAllTasks.trigger({ usePrevPayload: true }));
    } else if (
      viewMode === TASK_VIEW_MODES.BOARD_STATUS ||
      viewMode === TASK_VIEW_MODES.BOARD_PRIORITY
    ) {
      yield put(refreshTaskForBoardView.trigger());
    }
  } catch (error) {
    yield put(createTask.failure({ error }));
  } finally {
    yield put(createTask.fulfill());
  }
}

export function* editTaskSaga({ payload }) {
  try {
    GTM_TRACK_EVENT(GTM_EVENTS.ACTIONS_TASKS_UPDATED);
    const {
      formData,
      level,
      entityId,
      onSuccess,
      viewMode,
      isSingleEditComplete,
    } = payload;
    const response = yield call(request, `${PM_URL}/${payload.taskId}`, {
      method: 'PUT',
      payload: formData,
    });
    yield put(
      editTask.success({
        response,
        successMessage: isSingleEditComplete
          ? SUCCESS_MESSAGES.COMPLETE_TASK
          : SUCCESS_MESSAGES.UPDATE_TASK,
      })
    );

    if (onSuccess) onSuccess(response?.data);
    if (level && entityId) {
      yield put(fetchTasksByEntity.trigger({ level, entityId }));
      if (formData.status === TASK_STATUS.COMPLETED) {
        yield put(fetchActivities.trigger({ level, entityId }));
      }
    } else if (viewMode === TASK_VIEW_MODES.LIST) {
      yield put(fetchAllTasks.trigger({ usePrevPayload: true }));
    } else if (
      viewMode === TASK_VIEW_MODES.BOARD_STATUS ||
      viewMode === TASK_VIEW_MODES.BOARD_PRIORITY
    ) {
      yield put(refreshTaskForBoardView.trigger());
    }
  } catch (error) {
    yield put(editTask.failure({ error }));
  } finally {
    yield put(editTask.fulfill());
  }
}

export function* editEntityTaskSaga({ payload }) {
  try {
    const { taskId, formData, onSuccess } = payload;
    const response = yield call(request, `${PM_URL}/${taskId}`, {
      method: 'PUT',
      payload: formData,
    });
    yield put(
      editEntityTask.success({
        response: response.data,
        successMessage: SUCCESS_MESSAGES.UPDATE_TASK,
      })
    );
    if (onSuccess) onSuccess(response?.data);
  } catch (error) {
    yield put(editEntityTask.failure({ error }));
  } finally {
    yield put(editEntityTask.fulfill());
  }
}

export function* putTaskSaga({ payload }) {
  try {
    GTM_TRACK_EVENT(GTM_EVENTS.ACTIONS_TASKS_UPDATED);
    const { taskId, ..._payload } = payload;

    yield call(request, `${PM_URL}/${taskId}`, {
      method: 'PATCH',
      payload: _payload,
    });
  } catch (error) {
    yield put(putTask.failure({ error }));
  } finally {
    yield put(putTask.fulfill());
  }
}

export function* logTimeSaga({ payload }) {
  try {
    const { taskId, formData, onSuccess } = payload;
    const response = yield call(request, `${PM_URL}/${taskId}/work-log`, {
      method: 'POST',
      payload: formData,
    });
    yield put(
      logTime.success({
        response,
        successMessage: SUCCESS_MESSAGES.LOG_TIME,
      })
    );
    if (onSuccess) onSuccess(response?.data);
  } catch (error) {
    yield put(logTime.failure({ error }));
  } finally {
    yield put(logTime.fulfill());
  }
}

export function* deleteTaskWorkLogSaga({ payload }) {
  try {
    const { taskId, workLogId, onSuccess } = payload;
    const response = yield call(
      request,
      `${PM_URL}/${taskId}/work-log/${workLogId}`,
      { method: 'DELETE' }
    );
    yield put(
      deleteTaskWorkLog.success({
        response,
        successMessage: SUCCESS_MESSAGES.DELETE_WORK_LOG,
      })
    );
    if (onSuccess) onSuccess(response?.data);
  } catch (error) {
    yield put(deleteTaskWorkLog.failure({ error }));
  } finally {
    yield put(deleteTaskWorkLog.fulfill());
  }
}

export default function* root() {
  yield all([
    takeLatest(fetchAllTasks.TRIGGER, fetchAllTasksSaga),
    takeLatest(exportTasks.TRIGGER, exportTasksSaga),
    takeLatest(fetchTasksById.TRIGGER, fetchTasksByIdSaga),
    takeLatest(fetchTasksByIds.TRIGGER, fetchTasksByIdsSaga),
    takeLatest(fetchTaskChangelog.TRIGGER, fetchTaskChangelogByTaskIdSaga),
    takeLatest(fetchTasksByEntity.TRIGGER, fetchTasksByEntitySaga),
    takeLatest(fetchMoreTasksByEntity.TRIGGER, fetchLoadMoreTasksByEntitySaga),
    takeEvery(archiveTask.TRIGGER, archiveTaskSaga),
    takeEvery(completeTask.TRIGGER, completeTaskSaga),
    takeEvery(completeEntityTask.TRIGGER, completeEntityTaskSaga),
    takeEvery(resolveChecklist.TRIGGER, resolveChecklistSaga),
    takeEvery(markInProgressTask.TRIGGER, markInProgressTaskSaga),
    takeEvery(reAssignTask.TRIGGER, reAssignTaskSaga),
    takeEvery(bookmarkTask.TRIGGER, bookmarkTaskSaga),
    takeEvery(createTask.TRIGGER, createTaskSaga),
    takeEvery(editTask.TRIGGER, editTaskSaga),
    takeEvery(editEntityTask.TRIGGER, editEntityTaskSaga),
    takeEvery(fetchPartialTasks.TRIGGER, fetchPartialTasksSaga),
    takeEvery(putTask.TRIGGER, putTaskSaga),
    takeEvery(logTime.TRIGGER, logTimeSaga),
    takeEvery(deleteTaskWorkLog.TRIGGER, deleteTaskWorkLogSaga),
  ]);
}
